<template>
  <div class="diag-tooltip">
    <button @click="showTooltip()" class="anim-zoom">{{tooltipCont[0]}}</button>
    <div v-show="toolTipShow" ref="tooltipText" class="tooltip-text light-dark-int animated fadeIn" :style="tooltipStyles">
      <p v-html="tooltipCont[1]"></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tooltipCont: {
      type: Array,
      required: true
    },
    tooltipWidth: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tooltipTop: 0,
      tooltipLeft: 0,
      toolTipShow: false
    };
  },
  methods: {
    showTooltip() {
      this.toolTipShow = !this.toolTipShow;
      var div = this.$refs.tooltipText;
      setTimeout(
        function() {
          var rect = div.getBoundingClientRect();
          this.tooltipTop = -rect.height;
        }.bind(this),
        1
      );
      var tooltipWi = parseInt(div.style.width)
      this.tooltipLeft = -(tooltipWi / 2.7)+'px';
    }
  },
  computed: {
    tooltipPos() {
      return this.tooltipTop + "px";
    },
    tooltipStyles() {
      return {
        top: this.tooltipPos,
        left: this.tooltipLeft,
        width: this.tooltipWidth + "px"
      };
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/mixins.scss";
@import "../../sass/helpers/variables.scss";
.diag-tooltip {
  position: relative;
  display: inline-block;
  button {
    @include shadow (0 0 5px black);
    padding: 5px;
    border-radius: 5px;
  }
  .tooltip-text {
    font-size: 1rem;
    line-height: 1.3rem;
    font-weight: normal;
    font-size: 1.2rem;
    text-align: left;
    border: solid 2px gray;
    border-radius: 7px;
    padding: 5px;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// DiagTooltip.vue?7f2e50ea